import VueMask from "v-mask";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Vue2Filters from "vue2-filters";
import mainOidc from "@/service/oidc";
import App from "./App.vue";
import SignalR from "./plugins/signalR";
import router from "./router";
import store from "./store";
import "sweetalert2/dist/sweetalert2.min.css";
import VCalendar from "v-calendar";
import { getBranding } from "@/config/branding";

Vue.config.productionTip = false;

Vue.use(VueMask);
Vue.use(Vue2Filters);
Vue.use(SignalR);
Vue.use(VueSweetalert2);

Vue.use(VCalendar);

const brand = getBranding();
document.title = brand.siteName;
const faviconLink = document.querySelector("link[rel~='icon']");
if (faviconLink && brand.favicon) {
	faviconLink.href = brand.favicon;
}

if (mainOidc && typeof mainOidc.useRouter === "function") {
	mainOidc.useRouter(router);
}

mainOidc.startup().then((ok) => {
	if (ok) {
		new Vue({
			router,
			store,
			render: (h) => h(App),
		}).$mount("#app");
	}
});
